import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { INoRowsOverlayParams } from '@ag-grid-community/core';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { translationProvider } from './i18n/translation.provider';

@Component({
  standalone: true,
  selector: 'rx-custom-ag-no-rows',
  templateUrl: './custom-no-rows-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslocoModule],
  providers: [translationProvider],
})
export class CustomNoRowsOverlayComponent {

  noDataImagePath = input('/assets/images/empty-data-roomex.png')

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public params: INoRowsOverlayParams | any; // Ag-Grid ticket - AG-3353	Standardize all callbacks

  agInit(params: INoRowsOverlayParams): void {
    this.params = params;
  }

  get hasAnyColumnsVisible(): boolean {
    return this.params && !!this.params.api.columnModel.displayedColumns.length;
  }

}
